export default function FooterHeader() {
  return (
    <header>
      <span className="subheading">Contact</span>
      <h2 className="heading-secondary">Let`s Connect</h2>
    </header>
  );
}
